/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Free_NothingInputs */



/**
* | output |
* | --- |
* | "Free plan — nothing to pay." |
*
* @param {Dashboard_Billing_Free_NothingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_free_nothing = /** @type {((inputs?: Dashboard_Billing_Free_NothingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Free_NothingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kostenloser Plan — nichts zu zahlen.")
	return /** @type {LocalizedString} */ ("Free plan — nothing to pay.")
});